import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { VerificacionObraService } from 'src/app/datos/verificacion-obra.service';
import { HttpSession, Util } from 'src/app/libs/ruvpp-angular2-comun/index';
import { ServicioIndicadorCarga } from 'src/app/libs/ruvpp-angular2-comun/indicador-carga';
import { ServicioAlertas } from 'src/app/libs/ruvpp-angular2-comun/ServicioAlertas';
import { OrdenVerificacionDTO, OutputVistaInformacionGeneral, Reportes, SeguridadSalida } from 'src/app/modelo';
import { AvanceObraComponent } from '../avance-obra/avance-obra.component';
import { EcotecnologiasAtributosComponent } from '../ecotecnologias-atributos/ecotecnologias-atributos.component';
import { FuncionamientoComponent } from '../funcionamiento/funcionamiento.component';
import { HabitabilidadComponent } from '../habitabilidad/habitabilidad.component';
import { InicioObraComponent } from '../inicio-obra/inicio-obra.component';
import { SiseviveEcocasaComponent } from '../sisevive-ecocasa/sisevive-ecocasa.component';
import { VerticalidadComponent } from '../verticalidad/verticalidad.component';
import { environment } from 'src/environments/environment';
import { DonacionesEquipamientoComponent } from '../donaciones-equipamiento/donaciones-equipamiento.component';

//@Autor: Ernesto López Hdez
@Component({
    selector: 'app-tabs-verificacion',
    templateUrl: './tabs-verificacion.component.html',
    //styleUrls: ['./tabs-verificacion.component.css']
})
export class TabsVerificacionComponent implements OnInit {

    public activeTab: string;
    public user: SeguridadSalida;
    public usuario: string;
    public verificador: string;
    public reportes: Reportes;
    public ordenVerificacion: OrdenVerificacionDTO;
    public url: string;

    @ViewChild('inicioObra') inicioObra: InicioObraComponent;
    @ViewChild('avanceObra') avanceObra: AvanceObraComponent;
    @ViewChild('habitabilidad') habitabilidad: HabitabilidadComponent;
    @ViewChild('ecotecnologias') ecotecnologias: EcotecnologiasAtributosComponent;
    @ViewChild('verticalidad') verticalidad: VerticalidadComponent;
    @ViewChild('siseviveEcocasa') siseviveEcocasa: SiseviveEcocasaComponent;
    @ViewChild('funcionamiento') funcionamiento: FuncionamientoComponent;
    @ViewChild('donacionesEquipamiento') donacionesEquipamiento: DonacionesEquipamientoComponent;

    public vistaInformacionGeneral: OutputVistaInformacionGeneral;

    /**
     * 
     * @param servicioIndicadorCarga
     * @param servicioAlertas
     * @param service
     * @param _router
     * @param spinner
     */
    constructor(private servicioIndicadorCarga: ServicioIndicadorCarga, private servicioAlertas: ServicioAlertas, private service: VerificacionObraService, private _router: Router, private spinner: NgxSpinnerService) {

        this.user = HttpSession.getAttribute('USER');

        if (this.user != null) {
            this.usuario = `${HttpSession.getAttribute('USER_NAME')}`;
            this.verificador = `${HttpSession.getAttribute('USER_VERIFICADOR')}`;
        }

        this.vistaInformacionGeneral = HttpSession.getAttribute('ENTITY');

        this.url = environment.url;

        console.log('TabsVerificacionComponent -->> ', new Date());
    }

    /**
     * 
     */
    private tabInit(): void {

        this.reportes = HttpSession.getAttribute('REPORTES');

        if (this.reportes.InicioObra == true) {
            this.activeTab = 'pestana1';
        } else {
            if (this.reportes.AvanceObra == true) {
                this.activeTab = 'pestana2';
            }
            else {
                if (this.reportes.Habitabilidad == true) {
                    this.activeTab = 'pestana3';
                }
                else {

                    if (this.reportes.EcotecnologiasAtributos == true) {
                        this.activeTab = 'pestana4';
                    }
                    else {
                        if (this.reportes.Verticalidad == true) {
                            this.activeTab = 'pestana5';
                        }
                        else {
                            if (this.reportes.SiseviveEcocasa == true) {
                                this.activeTab = 'pestana6';
                            }
                        }
                    }
                }
            }
        }

    }

    /**
     * 
     */
    ngOnInit(): void {

        let ordenVerificacion = HttpSession.getAttribute('ORDEN_VERIFICACION');

        if (ordenVerificacion != null) {
            this.ordenVerificacion = ordenVerificacion;
        }

        this.tabInit();

        this.getMessageLoading(this.activeTab);

        setTimeout(() => {
            this.loading(this.activeTab);
        }, 2000);

    }

    /**
    * 
    */
    public Salir(): void {
        HttpSession.clear();
        Util.forward(this._router, 'Login');
    }

    /**
    * 
    * @param tab
    */
    public changeTab(tab: string): void {

        this.activeTab = tab;

        this.getMessageLoading(this.activeTab);

        this.loading(this.activeTab);
    }

    /**
     * 
     * @param tab
     */
    public getMessageLoading(tab: string): void {

        let mensaje: string = '';

        switch (tab) {
            case 'pestana1': mensaje = 'Inicio de obra'; break;
            case 'pestana2': mensaje = 'Avance de obra'; break;
            case 'pestana3': mensaje = 'Habitabilidad'; break;
            case 'pestana4': mensaje = 'Ecotecnologías / atributos'; break;
            case 'pestana5': mensaje = 'Verticalidad'; break;
            case 'pestana6': mensaje = 'Sisevive - Ecocasa'; break;
            case 'pestana7': mensaje = 'Funcionamiento'; break;
            case 'pestana8': mensaje = 'Donaciones Equipamiento'; break;
        }

        Util.showLoadingMessage(this.spinner, `Obteniendo información de ${mensaje}`);

    }

    /**
     * 
     * @param tab
     */
    public async loading(tab: string) {

        switch (tab) {
            case 'pestana1': await this.inicioObra.init(); break;
            case 'pestana2': await this.avanceObra.init(); break;
            case 'pestana3': await this.habitabilidad.init(); break;
            case 'pestana4': await this.ecotecnologias.init(); break;
            case 'pestana5': await this.verticalidad.init(); break;
            case 'pestana6': await this.siseviveEcocasa.init(); break;
            case 'pestana7': await this.funcionamiento.init(); break;
            case 'pestana8': await this.donacionesEquipamiento.init(); break;
        }

        setTimeout(() => {
            Util.hideLoadingMessage();
        }, 500);

    }

    /**
     * 
     */
    public getOrdenVerificacion(): OrdenVerificacionDTO {

        let ordenVerificacion: OrdenVerificacionDTO = <OrdenVerificacionDTO>{};

        let entity: OutputVistaInformacionGeneral = HttpSession.getAttribute('ENTITY');

        if (entity != null) {

            ordenVerificacion = <OrdenVerificacionDTO>{
                idOrdenVerificacion: entity.ordenVerificacion,
                nombreFrente: entity.nombreFrente,
                totalViviendas: entity.totalViviendas,
                modalidad: entity.modalidad
            };

        }

        return ordenVerificacion;

    }

}
